import styled from '@emotion/styled';

interface TableWrapperProps {
  rowFill: 'odd' | 'even' | 'none';
}

export const TableWrapper = styled('table', {
  shouldForwardProp: prop => prop !== 'rowFill',
})<TableWrapperProps>(({ rowFill }) => ({
  width: '100%',
  borderCollapse: 'separate' as const,
  borderSpacing: 0,
  tableLayout: 'fixed' as const,
  border: '1px solid #D9E4F5',
  borderRadius: '1rem',
  overflow: 'hidden',
  '& tr:nth-of-type(odd)': {
    backgroundColor: rowFill === 'odd' ? '#F5F6F8' : '#fff',
  },
  '& tr:nth-of-type(even)': {
    backgroundColor: rowFill === 'even' ? '#F5F6F8' : '#fff',
  },
  '& tr:not(:last-child) > th, & tr:not(:last-child) > td': {
    borderBottom: '1px solid #D9E4F5',
  },
}));

export const TableHeaderWrapper = styled('thead')({});

export const TableBodyWrapper = styled('tbody')({});

export const RowWrapper = styled('tr')({
  '&:first-of-type > th:first-of-type, &:first-of-type > td:first-of-type': {
    borderTopLeftRadius: '1rem',
  },
  '&:first-of-type > th:last-of-type, &:first-of-type > td:last-of-type': {
    borderTopRightRadius: '1rem',
  },
  '&:last-of-type > th:first-of-type, &:last-of-type > td:first-of-type': {
    borderBottomLeftRadius: '1rem',
  },
  '&:last-of-type > th:last-of-type, &:last-of-type > td:last-of-type': {
    borderBottomRightRadius: '1rem',
  },
});

const cellStyles = {
  padding: '1rem',
  textAlign: 'left' as const,
  verticalAlign: 'top' as const,
};

export const HeaderCellWrapper = styled('th')({
  ...cellStyles,
  fontWeight: 'inherit',
});

export const CellWrapper = styled('td')({
  ...cellStyles,
});
